(function () {
  var STORAGE_KEY = 'krownProductInterest';
  var LAST_COLLECTION_KEY = 'krownLastCollectionUrl';
  var FALLBACK_COLLECTION_URL = '/collections/all';

  function getItems() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (err) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (err) {
      /* sessionStorage unavailable (private mode, quota) */
    }
  }

  function clearItems() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (err) {}
  }

  // Remember the last collection page visited, so "Buy more" can send the
  // shopper back to browse instead of dead-ending on the contact page.
  try {
    if (window.KROWN && window.KROWN.settings && window.KROWN.settings.current_collection_url) {
      sessionStorage.setItem(LAST_COLLECTION_KEY, window.KROWN.settings.current_collection_url);
    }
  } catch (err) {}

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.catalog-interest-link');
    if (link) {
      var raw = link.getAttribute('data-product-interest');
      if (raw) {
        try {
          var product = JSON.parse(raw);
          var items = getItems();
          var existing = items.filter(function (item) {
            return item.url === product.url;
          })[0];
          if (existing) {
            existing.qty = (existing.qty || 1) + 1;
          } else {
            items.push({ url: product.url, title: product.title, image: product.image, qty: 1 });
          }
          saveItems(items);
        } catch (err) {
          /* malformed payload — link still navigates normally */
        }
      }
      return;
    }

    var removeButton = e.target.closest('[data-remove-interest-item]');
    if (removeButton) {
      var url = removeButton.getAttribute('data-url');
      var remaining = getItems().filter(function (item) {
        return item.url !== url;
      });
      saveItems(remaining);
      renderProductInterestCard();
    }
  });

  function buildRow(item, removeIconTemplate) {
    var row = document.createElement('div');
    row.className = 'kt-product-interest-item';
    row.setAttribute('data-url', item.url);

    var imageWrap = document.createElement('div');
    imageWrap.className = 'kt-product-interest-item__image-wrap';

    var img = document.createElement('img');
    img.className = 'kt-product-interest-item__image';
    img.alt = '';
    img.width = 56;
    img.height = 56;

    if (item.image) {
      imageWrap.classList.add('kt-product-interest-item__image-wrap--loading');
      img.addEventListener(
        'load',
        function () {
          imageWrap.classList.remove('kt-product-interest-item__image-wrap--loading');
          img.alt = item.title || '';
          img.classList.add('is-loaded');
        },
        { once: true }
      );
      img.addEventListener(
        'error',
        function () {
          imageWrap.classList.remove('kt-product-interest-item__image-wrap--loading');
        },
        { once: true }
      );
      img.src = item.image;
    }
    imageWrap.appendChild(img);

    var info = document.createElement('div');
    info.className = 'kt-product-interest-item__info';

    var title = document.createElement('span');
    title.className = 'kt-product-interest-item__title';
    title.textContent = item.title || '';
    info.appendChild(title);

    if (item.qty > 1) {
      var qty = document.createElement('span');
      qty.className = 'kt-product-interest-item__qty';
      qty.textContent = 'Qty: ' + item.qty;
      info.appendChild(qty);
    }

    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'kt-remove';
    removeButton.setAttribute('data-remove-interest-item', '');
    removeButton.setAttribute('data-url', item.url);
    removeButton.setAttribute('aria-label', 'Remove');
    if (removeIconTemplate) {
      removeButton.appendChild(removeIconTemplate.content.cloneNode(true));
    } else {
      removeButton.textContent = '×';
    }

    row.appendChild(imageWrap);
    row.appendChild(info);
    row.appendChild(removeButton);
    return row;
  }

  function renderProductInterestCard() {
    var card = document.querySelector('[data-product-interest-card]');
    if (!card) return;

    var successMarker = document.querySelector('[data-contact-form-success="true"]');
    if (successMarker) {
      clearItems();
      card.hidden = true;
      return;
    }

    var items = getItems();
    if (!items.length) {
      card.hidden = true;
      return;
    }

    var list = card.querySelector('[data-product-interest-list]');
    var inputsContainer = card.querySelector('[data-product-interest-inputs]');
    var removeIconTemplate = card.querySelector('[data-product-interest-remove-icon]');
    var buyMoreLink = card.querySelector('[data-buy-more-link]');

    if (list) {
      list.innerHTML = '';
      items.forEach(function (item) {
        list.appendChild(buildRow(item, removeIconTemplate));
      });
    }

    if (inputsContainer) {
      inputsContainer.innerHTML = '';
      items.forEach(function (item, index) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'contact[Product ' + (index + 1) + ']';
        var value = item.title || '';
        if (item.qty > 1) value += ' (Qty: ' + item.qty + ')';
        value += ' - ' + item.url;
        input.value = value;
        inputsContainer.appendChild(input);
      });
    }

    if (buyMoreLink) {
      var lastCollectionUrl;
      try {
        lastCollectionUrl = sessionStorage.getItem(LAST_COLLECTION_KEY);
      } catch (err) {}
      buyMoreLink.setAttribute('href', lastCollectionUrl || FALLBACK_COLLECTION_URL);
    }

    card.hidden = false;
    card.removeAttribute('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderProductInterestCard);
  } else {
    renderProductInterestCard();
  }
})();
